import { render, staticRenderFns } from "./SimpleEvent.vue?vue&type=template&id=2a0efd56&"
import script from "./SimpleEvent.vue?vue&type=script&lang=js&"
export * from "./SimpleEvent.vue?vue&type=script&lang=js&"
import style0 from "./SimpleEvent.vue?vue&type=style&index=0&id=2a0efd56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports